import { createFileRoute } from "@tanstack/react-router";

import { RoutePage, routeEntry } from "./routeTable";

const entry = routeEntry("/kcc/sales-planning");

export const Route = createFileRoute("/kcc/sales-planning")({
  head: () => ({
    meta: [
      { title: "KCC sales planning — LevelLoad" },
      { name: "description", content: "KCC sales planning — LevelLoad transport planning." },
      { property: "og:title", content: "KCC sales planning — LevelLoad" },
      { property: "og:description", content: "KCC sales planning — LevelLoad transport planning." },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary_large_image" },
    ],
  }),
  component: RouteComponent,
});

function RouteComponent() {
  return <RoutePage entry={entry} />;
}
